import { trans } from '@lingoda/i18n';
import type { PaymentMethodType } from '@lingoda/payments';
import type { SectionName } from '@lingoda/sections';
import { buildValidator } from '@lingoda/forms';
import { type CheckoutPurchase } from '../types';
import { type AgreementsFormValues, validateAgreements } from './Agreements';

export interface FormValues extends AgreementsFormValues {
    paymentMethod?: string;
    termsAndConditions?: boolean;
    ageAboveEighteen?: boolean;
    validPaymentMethod?: boolean;
    marketing?: boolean;
    paymentMethodType?: PaymentMethodType;
    name?: string;
    country?: string;
    userName?: string;
    email?: string;
    section?: SectionName;
}

interface Props {
    purchase: CheckoutPurchase;
}

export const validate = (values: FormValues, { purchase }: Props) => {
    const errors: { [key: string]: unknown } = buildValidator({
        paymentMethod: {
            required: true,
        },
        validPaymentMethod: {
            required: true,
        },
        termsAndConditions: {
            required: trans('form-validation-terms-and-conditions', {}, 'public-common'),
        },
        ageAboveEighteen: {
            required: trans('form-validation-please-confirm-age', {}, 'public-common'),
        },
    })(values);

    const agreementErrors = validateAgreements(purchase.agreements, values);

    return {
        ...errors,
        ...(agreementErrors && { agreements: agreementErrors }),
    };
};
